import React from "react";

function IconStarFalse(props) {
  return (
    <div className={props.className}>
        <svg
            height={props.height}
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 270 258"
        >
            <path
            className={props.pathClass ? props.pathClass : "g1-fill"}
            d="M12110.9 3376.27l28.6-59.13c.9-1.88 2.8-3.07 4.9-3.07 2 0 3.9 1.19 4.9 3.07l28.5 59.13 65 8.86c2.1.29 3.8 1.73 4.5 3.71.6 1.98.1 4.16-1.4 5.6l-47.5 45.41 11.7 64.6c.4 2.05-.5 4.14-2.1 5.36-1.7 1.23-4 1.38-5.8.39l-57.8-31.06-57.9 31.06c-1.8.99-4 .84-5.7-.39-1.7-1.22-2.6-3.31-2.2-5.36l11.7-64.6-47.4-45.41c-1.5-1.44-2.1-3.62-1.4-5.6.6-1.98 2.3-3.42 4.4-3.71l65-8.86zm33.5-36.34l-21 43.36c-1.8 3.82-5.4 6.46-9.6 7.04l-47.7 6.5 34.7 33.3c3.1 2.93 4.5 7.21 3.7 11.38l-8.5 47.38 42.4-22.78c3.7-2.01 8.2-2.01 11.9 0l42.5 22.78-8.6-47.38c-.7-4.17.6-8.45 3.7-11.38l34.8-33.3-47.7-6.5c-4.2-.58-7.9-3.22-9.7-7.04l-20.9-43.36z"
            transform="translate(-15755.7 -4336.4) scale(1.30848)"
            ></path>
        </svg>
    </div>
  );
}

export default IconStarFalse;
